export default {
  text: '#353535',
  primary: '#353535',
  secondary: '#e7e7e7',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#020303'
}
